import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CustomListsContext = createContext({});

export function CustomListsProvider({ children }) {
  const [lists, setLists] = useState({});
  const [loaded, setLoaded] = useState(false);

  const fetchLists = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/custom-lists`, { withCredentials: true });
      setLists(data);
      setLoaded(true);
    } catch {
      // Not logged in or error — use empty
      setLoaded(true);
    }
  }, []);

  useEffect(() => { fetchLists(); }, [fetchLists]);

  // Helper: get active items for a list as [{value, label}]
  const getOptions = (listName) => {
    const items = lists[listName] || [];
    return items.filter(i => i.active !== false);
  };

  // Helper: get just the labels
  const getLabels = (listName) => getOptions(listName).map(i => i.label);

  // Helper: get just the values  
  const getValues = (listName) => getOptions(listName).map(i => i.value);

  return (
    <CustomListsContext.Provider value={{ lists, loaded, fetchLists, getOptions, getLabels, getValues }}>
      {children}
    </CustomListsContext.Provider>
  );
}

export function useCustomLists() {
  return useContext(CustomListsContext);
}
